/// <amd-module name="SuiteCommerce.Blog.SuggestionsList.View"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.Blog.SuggestionsList.View", ["require", "exports", "Backbone", "sc_blog_suggestions_list.tpl", "SuiteCommerce.Blog.Post.Collection", "SuiteCommerce.Blog.Common.Searcher.Helper", "SuiteCommerce.Blog.PostList.View", "SuiteCommerce.Blog.PostList.Model", "SuiteCommerce.Blog.PostCard.View"], function (require, exports, Backbone_1, suggestionsListTemplate, Post_Collection_1, BlogPostSearcher_Helper_1, PostList_View_1, PostList_Model_1, PostCard_View_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.SuggestionsListView = void 0;
    var SuggestionsListView = /** @class */ (function (_super) {
        __extends(SuggestionsListView, _super);
        function SuggestionsListView(options) {
            var _this = _super.call(this, options) || this;
            _this.template = suggestionsListTemplate;
            if (options && options.model && options.model.searchOptions) {
                _this.fetchSuggestionList();
            }
            return _this;
        }
        SuggestionsListView.prototype.fetchSuggestionList = function () {
            var _this = this;
            return this.model.suggestionList.fetch(BlogPostSearcher_Helper_1.BlogPostSearcherHelper.buildRequestBody(this.model.searchOptions)).done(function () { return _this.render(); });
        };
        Object.defineProperty(SuggestionsListView.prototype, "childViews", {
            get: function () {
                var _this = this;
                return {
                    'PostList.View': function () {
                        return new PostList_View_1.PostListView({
                            model: new PostList_Model_1.PostListModel({
                                postCardLayout: PostCard_View_1.PostCardLayout.horizontal,
                                posts: new Post_Collection_1.PostCollection(_this.model.suggestionList.sample(_this.model.quantityOfSuggestions)),
                                showPostCardsPlaceholders: _this.model.suggestionList.size() === 0,
                                postCardPlaceholdersQuantity: _this.model.quantityOfSuggestions,
                            }),
                        });
                    },
                };
            },
            enumerable: false,
            configurable: true
        });
        SuggestionsListView.prototype.getContext = function () {
            return (this.model.searchOptions)
                ? {
                    title: this.model.title,
                    showSuggestions: this.model.suggestionList.size() > 0,
                    suggestionMessage: this.model.suggestionMessage,
                    posts: this.model.suggestionList,
                    render: true,
                } : {
                render: false,
            };
        };
        return SuggestionsListView;
    }(Backbone_1.View));
    exports.SuggestionsListView = SuggestionsListView;
});
